import React, { useEffect, useState } from 'react'
import rafer from './image/refer.png'
import bann from './image/giftbanner.png'
import bann1 from './image/banner (1).png'
import { NavLink, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ToastContainer } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import { Api_Url } from './APIUrl'

const Refer = () => {


 const [referral, setreferral] = useState('');
 const [Name, setName] = useState();
 const [Number, setNumber] = useState();
 const [Reffer, setrefferal] = useState();



//  const handleChange = () => {
//     ReferCode();
// };








  const fetchProfile = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(`${Api_Url}api/profile`, requestOptions);
      const result = await response.json();

      if (result.success) { 
        setrefferal(result.data.user.referral_code)
        setNumber(result.data.user.referred_by)
      }else if (result.message === "Token has expired.") {
        // Token has expired, navigate to the login page
        localStorage.removeItem("token");  // Optionally remove the expired token
        window.location.href = "/";  // Redirect to login page
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

// const handleRefer = () => {
//     try {
//       const referralCode = Reffer ; // Static or dynamic referral code
//       const referralLink = `${Api_Url}api/profile=${referralCode}`;
  
//       // WhatsApp Message
//       const message = `🎲Brothers ludo🎲 आपका स्वागत करता है 🙏 हेल्पलाइन नंबर 👉.......... ( केवल WhatsApp call & message)👈 🙏withdrawal मात्र 2 मिनट में मिलेगा🙏
//       COMMISSION 5% : REFERRAL 2% FOR ALL GAMES ${referralCode}.
//   👇
//   ${referralLink}`;
  
      
//       const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  
     
//       window.open(whatsappUrl, "_blank");
//     }
//      catch (error) {
//       console.error("Error:", error);
//       toast("An unexpected error occurred.");
//     }

//   };

  

// const handleRefer = () => {
//     try {
//       const myHeaders = new Headers();
//       myHeaders.append("Content-Type", "application/json");
//       myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

//       const raw = JSON.stringify({
//         referral_code: referral, 
//       });

//       const requestOptions = {
//         method: "POST",
//         headers: myHeaders,
//         body: raw,
//         redirect: "follow",
//       };

//       fetch("https://brothersludo.in/api/update-referral", requestOptions)
//         .then((response) => response.json())
//         .then((result) => {
//           if (result.success == true) {
//             toast(result?.message);

//             // Prepare WhatsApp message
//             const referrerName = result?.data?.referrer_name || "Someone";
//             const referredBy = result?.data?.referred_by || "unknown";
//             const referralCode = referral || "ABCD";

//             const message = `Hello! ${referrerName} has invited you to join Brothers Ludo. Use this referral code: *${referralCode}* (Referred by: ${referredBy}). Download the app now and start playing!`;

//             // Encode the message for WhatsApp
//             const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

//             // Open WhatsApp
//             window.open(whatsappUrl, "_blank");
//           } else {
//             toast("Failed to generate referral code.");
//           }
//         })
//         .catch((error) => {
//           console.error("Error:", error);
//           toast("An error occurred. Please try again.");
//         });
//     } catch (error) {
//       console.error("Error:", error);
//       toast("An unexpected error occurred.");
//     }
//   };


const handleRefer = () => {
  try {
    // Static or dynamic referral code
    const referralCode = Reffer; // Make sure Reffer contains the actual referral code

    // Ensure the base URL points to the correct domain
    const Api_Url = "https://brothersludo.in/";

    // Construct the referral link with a query parameter for referral
    const referralLink = `${Api_Url}?referral=${referralCode}`;

    // WhatsApp Message
    const message = `🎲Brothers ludo🎲 आपका स्वागत करता है 🙏 हेल्पलाइन नंबर 👉.......... ( केवल WhatsApp call & message)👈 🙏withdrawal मात्र 2 मिनट में मिलेगा🙏
    COMMISSION 5% : REFERRAL 2% FOR ALL GAMES ${referralCode}.
👇
${referralLink}`;

    // Encode the message and open the WhatsApp URL
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  } catch (error) {
    console.error("Error:", error);
    toast("An unexpected error occurred.");
  }
};

  

const Navigate= useNavigate()
  useEffect(() => { 
    if(!localStorage.getItem('token')){ 
        Navigate("/") 
    }
    fetchProfile();
  }, [])
  return (
    <div>


<ToastContainer/>

        <div className='container'>
            <div className='row'>
                <div className='col-lg-6 col-sm-12 m-auto mt-5'>
                         
                         <img src={rafer}  style={{width:'100%'}}/>

                         <div className='mt-3 text-center'>
                            <h5>Earn now unlimited🥳 </h5>
                            <p>Refer your friends now! </p>
                         </div>



                         <div className='mt-3 text-center'>
                            <h5>Current Earning: <NavLink to="/redeem"  style={{textDecoration:'none'}}>  Redeem  </NavLink> </h5>
                            <p>Total Earned:0</p>

                            <div style={{backgroundColor:'#e9ecef', height:'13px', borderRadius:'15px'}}>

                            </div>

                            <div style={{display:'flex', justifyContent:'space-between'}}>
                                <p>Max: ₹10,000</p>
                                <p>Upgrade Limit</p>
                            </div>

                            <div>
                                <strong className='text-center mb-1'>Your Refer Code: {Reffer}</strong>
                                <h6 className='text-center'>Total Refers:{Number}</h6>
                            </div>



                            
                         </div>
                </div>
 
            </div>

            <div className='row'>
                <div className='col-lg-11 col-sm-12 mt-4'>
                <h5>Refer & Earn Rules   </h5>


                <div className='row mt-4' >
                    <div className='col-3'>
                        <img src={bann}  style={{width:'100%'}}/>
                    </div>
                    <div className='col-9 pt-3'>
                        <h6 className=''>When your friend signs up on Our website or App from your referral link,
                        </h6>
                        <span  style={{color:'green', fontSize:'14px'}}> You get 1% Commission on yourreferral's winnings.                        </span>
                    </div>
                </div>

                <div className='row mt-4 pb-4'  style={{borderBottom:'1px solid #e0e0e0'}} >
                    <div className='col-3'>
                        <img src={bann1}  style={{width:'100%'}}/>
                    </div>
                    <div className='col-9 pt-3'>
                        <h6 className=''>Suppose your referral plays a battle for ₹10000 Cash,</h6>
                        <span  style={{color:'green', fontSize:'14px'}}> You get₹100 Cash</span>
                    </div>
                </div>


                
                </div>
            </div>

            <div className='row mt-4'>
                 <div className="col-lg-12 mb-2">
            <div>
            <button
      className="btn w-100 py-2"
      style={{ backgroundColor: "#6c757d", color: "#fff" }}
      onClick={handleRefer}
    >
      Share on WhatsApp
    </button>
            </div>
        </div>
            </div>
        </div>
    </div>
  )
}

export default Refer